import React from 'react';
import { ConfirmDialog } from './ConfirmDialog';

export interface AbortConfirmDialogProps {
  onConfirm: () => void;
  onCancel: () => void;
}

export const AbortConfirmDialog: React.FC<AbortConfirmDialogProps> = ({
  onConfirm,
  onCancel,
}) => {
  return (
    <ConfirmDialog
      isOpen={true}
      title="确认中止"
      message="确定要中止当前任务吗？已完成的工作将被保留。"
      confirmLabel="确认中止"
      cancelLabel="继续执行"
      variant="danger"
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};

AbortConfirmDialog.displayName = 'AbortConfirmDialog';

export default AbortConfirmDialog;
